// externals
import type { FC, PropsWithChildren, MutableRefObject } from 'react';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

// libraries
import { CardHeader } from '@interstate/components/Card';
import { Typography } from '@interstate/components/Typography';
import { PaymentLoading } from '@makemydeal/dr-dash-components';
import { LoadingSectionParent } from '@makemydeal/dr-shared-components';
import * as accessoriesSelectors from '@makemydeal/dr-dash-store/selectors/accessoriesSelectors';
import { AccessoriesForm } from '@makemydeal/dr-activities-accessories';

// constants/enums
import { ACCESSORIES } from '../../constants';

// components/hooks
import { useScrollIntoView } from '../../utils/useScrollIntoView';
import { useBaseDealBreakpoint } from '../../utils/useBaseDealBreakpoint';
import { StretchHeightCard } from '../deskingActivity/DeskingCard.style';

interface AccessoriesCardProps {
    isInsideSlideOut?: boolean;
    shouldTriggerValidation?: boolean;
    isAccessoriesFormDirtyRef?: MutableRefObject<boolean>;
}

const AccessoriesCard: FC<PropsWithChildren<AccessoriesCardProps>> = ({
    isInsideSlideOut = false,
    isAccessoriesFormDirtyRef,
    shouldTriggerValidation = false
}) => {
    const elementRef = useRef<HTMLDivElement>(null);
    const uniqueScrollRequestId = useSelector(accessoriesSelectors.getUniqueScrollRequestId);
    const baseBreakPoint = useBaseDealBreakpoint();

    useScrollIntoView(elementRef, uniqueScrollRequestId);

    return (
        <LoadingSectionParent>
            <PaymentLoading testId="manual-accessory-loading-indicator" />
            <StretchHeightCard
                className="stretch-height-card"
                data-testid="accessories-card"
                header={
                    !isInsideSlideOut ? (
                        <div ref={elementRef}>
                            <CardHeader className="base-tab-title" title={<Typography variant="h3">{ACCESSORIES}</Typography>} />
                        </div>
                    ) : undefined
                }
                content={
                    <AccessoriesForm
                        isInsideSlideOut={isInsideSlideOut}
                        isAccessoriesFormDirtyRef={isAccessoriesFormDirtyRef}
                        shouldTriggerValidation={shouldTriggerValidation}
                        baseBreakPoint={baseBreakPoint}
                    />
                }
            />
        </LoadingSectionParent>
    );
};

export default AccessoriesCard;
